import { scrubRumEventUrls } from '@bridge/utils';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import env from 'lib/env';

export const isDatadogEnabled =
  Boolean(env.NEXT_PUBLIC_DATA_DOG_APPLICATION_ID) && Boolean(env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN);

if (isDatadogEnabled) {
  datadogRum.init({
    applicationId: env.NEXT_PUBLIC_DATA_DOG_APPLICATION_ID,
    clientToken: env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN,
    site: env.NEXT_PUBLIC_DATA_DOG_SITE,
    service: env.NEXT_PUBLIC_DATA_DOG_SERVICE,
    env: env.NEXT_NODE_ENV,
    // Must match the datadog-ci sourcemaps upload --release-version, or maps won't resolve.
    version: env.NEXT_PUBLIC_GIT_SHA,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackingConsent: 'not-granted',
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],
    beforeSend: scrubRumEventUrls,
  });
}

export { datadogRum };
